import React, { useEffect, useState } from 'react';
import IconCollection from '../../IconCollection/IconCollection';
import EditProfile from './EditProfile/EditProfile';
import AccessAndServices from './AccessAndServices/AccessAndServices';
import RatingInfo from './RatingInfo/RatingInfo';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { userLogout } from '../../redux/reducers/fotogritReducer';

const UserSetting = () => {
  const [userSettingTab, setUserSettingTab] = useState('EditProfile')
    const isMobile = window.innerWidth <= 768; // Assuming 768px as the breakpoint for mobile devices
  useEffect(() => {
    if (isMobile) {
      setUserSettingTab('')
    } else {
      setUserSettingTab('EditProfile')
    }
  }, [isMobile])
  const handleClick = (tabName) => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      setUserSettingTab((prevTab) => (prevTab === tabName ? '' : tabName));
    } else {
      setUserSettingTab(tabName);
    }
  };
  const [showWindow, setShowWindow] = useState(false)

 const dispatch = useDispatch();
  const navigate = useNavigate()
  const handleLogOut = () => {
    setShowWindow(false)
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("user_data");
    dispatch(userLogout({
      user: false,
      token: null,
      fullname: "",
      user_type: ""
    }));
    navigate('/sign-in')

};
const goBack = () => {
    navigate(-1); // Go back one step in history
  };

  return (
    <div className=' w-full mx-auto relative'>
      <div className='max-w-[1512px] w-full px-12 mx-auto h-24 py-4 flex items-center'>

        <div className='flex items-center gap-6 max-w-[200px] w-full'>
          <button onClick={() => goBack()} className='flex justify-center items-center gap-2 w-full cursor-pointer'>
            <IconCollection customClass='md:max-w-[25px] max-w-[10.16px] w-full md:h-[24px] h-[10.16px]' name="arrow-left" />
            <p className='text-[#4A4A4A] text-xl font-montserrat font-medium'>User Settings</p>
          </button>

        </div>
      </div>
      <div className='w-full h-[1px] border-b-[1px] border-b-[#CCCCCC]'></div>
      <div className='max-w-[1512px] w-full px-12 mx-auto'>
        <div className='w-full flex gap-6'>
          <div className='max-w-[240px] w-full h-full border-r-[1px] border-[#E8E8E8] '>

           <div className='pt-6 flex flex-col gap-2'>
            <button onClick={() => handleClick('EditProfile')} className={`px-2 md:px-6 py-2 max-w-full md:max-w-[216px]  w-full cursor-pointer h-12   ${userSettingTab === 'EditProfile' ? 'bg-transparent md:bg-primary text-primary md:text-white  hover:bg-transparent md:hover:bg-secondary' : 'hover:bg-slate-200  text-[#4A4A4A]'} text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium `} >
              EditProfile

              <div className='inline-block md:hidden'>
                {userSettingTab === 'EditProfile' ? <IconCollection name="arrow-up-color" /> : <IconCollection name="arrow-down" />}
              </div>

            </button>

            <div className='inline-block md:hidden'>
              {
                userSettingTab == 'EditProfile' && <EditProfile />
              }

            </div>
            <button onClick={() => handleClick('RatingInfo')} className={`px-2 md:px-6 py-2 max-w-full md:max-w-[216px]  w-full cursor-pointer h-12   ${userSettingTab === 'RatingInfo' ? 'bg-transparent md:bg-primary text-primary md:text-white  hover:bg-transparent md:hover:bg-secondary' : 'hover:bg-slate-200  text-[#4A4A4A]'} text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium `} >
              RatingInfo

              <div className='inline-block md:hidden'>
                {userSettingTab === 'RatingInfo' ? <IconCollection name="arrow-up-color" /> : <IconCollection name="arrow-down" />}
              </div>
            </button>

            <div className='inline-block md:hidden'>
              {
                userSettingTab == 'RatingInfo' && <RatingInfo />
              }

            </div>
            <button onClick={() => handleClick('AccessAndServices')} className={`px-2 md:px-6 py-2 max-w-full md:max-w-[216px]  w-full cursor-pointer h-12   ${userSettingTab === 'AccessAndServices' ? 'bg-transparent md:bg-primary text-primary md:text-white  hover:bg-transparent md:hover:bg-secondary' : 'hover:bg-slate-200  text-[#4A4A4A]'} text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium `} >
              Access And Services
              <div className='inline-block md:hidden'>
                {userSettingTab === 'AccessAndServices' ? <IconCollection name="arrow-up-color" /> : <IconCollection name="arrow-down" />}
              </div>
            </button>

            <div className='inline-block md:hidden'>
              {
                userSettingTab == 'AccessAndServices' && <AccessAndServices />
              }

              </div>
              <button onClick={()=>setShowWindow(true)} className='px-2 md:px-6 py-2 max-w-full md:max-w-[216px]  w-full cursor-pointer h-12   hover:bg-slate-200  text-[#4A4A4A] text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium '>
                  Logout
              </button>
          </div>
          </div>
          <div className='max-w-[1152px] hidden md:flex w-full  justify-center items-center'>
            <div className='max-w-[697px] w-full '>
              {
                userSettingTab == 'EditProfile' && <EditProfile />
              }
              {
                 userSettingTab == 'RatingInfo' && <RatingInfo />
              }
              {
                userSettingTab == 'AccessAndServices' && <AccessAndServices />
              }

            </div>
          </div>
        </div>
      </div>

       <div className={`fixed top-[-130px] left-0 right-0 bottom-0  z-10 w-full bg-black bg-opacity-25 flex justify-center items-center transition-all ${showWindow ? 'block' : 'hidden'}`}>
        <div className='bg-light rounded-md  w-full  px-10 py-6  max-w-[600px]'>
          <p className='text-[#1A1A1A] font-bebas text-[32px] text-center pt-10'>Are you sure you want to log out?</p>
          <div className='flex justify-center items-center gap-6 py-10'>
            <button className='max-w-[100px] w-full h-10 rounded bg-accent  text-white font-bebas text-xl' onClick={() => setShowWindow(false)} >No</button>
             <button className='max-w-[100px] w-full h-10 rounded bg-primary  text-white font-bebas text-xl' onClick={() => handleLogOut()}>Yes</button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default UserSetting;